module.exports = __webpack_public_path__ + "img/loginbj.c23ca47c.png";